import { render } from "./menuItem.component.vue?vue&type=template&id=4a731d19&scoped=true&ts=true"
import script from "./menuItem.component.vue?vue&type=script&lang=ts"
export * from "./menuItem.component.vue?vue&type=script&lang=ts"

import "./menuItem.component.vue?vue&type=style&index=0&id=4a731d19&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a731d19"]])

export default __exports__